import React from 'react'

import InputField from 'src/components/InputField'

const PartnerItem = ({
  i18n, partnerItem, setPartnerItem, partner_items, goal_partner_item, error,
  disable_donation_split, commonInputProps,
}) =>
  <InputField
    {...commonInputProps(i18n.t('beneficiary'))}
    type="select"
    id="partner_item"
    data-plg-donor-field="partnerItem"
    value={partnerItem?.external_id || ''}
    onChange={e =>
      setPartnerItem(partner_items.concat(goal_partner_item).find(pi =>
        pi.external_id == e.target.value
      ))
    }
    disabled={partner_items.length == 1}
    error={error}
    options={[{
      label: i18n.t(
        disable_donation_split
        ? 'choose_nonprofit'
        : 'split_among_nonprofits'
      ),
      value: goal_partner_item.external_id,
    }].concat(partner_items.map(pi => ({
      label: pi.beneficiary.name,
      value: pi.external_id,
    })))}
  />

export default PartnerItem
